import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  createMappingActivity,
  CreateMappingActivityPayload,
} from '@/services/create-mapping-activity'
import {
  createPulverizationActivity,
  CreatePulverizationActivityPayload,
} from '@/services/create-pulverization-activity'
import { queryClient } from '@/services/query-client'

import { GET_ACTIVITIES_QUERY } from '../queries/use-get-activities'
import { GET_CALENDAR_DIAGNOSES_QUERY } from '../queries/use-get-calendar-diagnoses'

type CreateActivityPayload =
  | { type: 'pulverization'; payload: CreatePulverizationActivityPayload }
  | { type: 'mapping'; payload: CreateMappingActivityPayload }

export function useCreateActivity() {
  const mutation = useMutation({
    mutationFn: ({ type, payload }: CreateActivityPayload) => {
      if (type === 'pulverization') {
        return createPulverizationActivity(payload)
      }

      if (type === 'mapping') {
        return createMappingActivity(payload)
      }

      return Promise.reject(new Error('Tipo de atividade inválido'))
    },
    onSuccess: () => {
      queryClient.invalidateQueries(GET_ACTIVITIES_QUERY)
      queryClient.invalidateQueries(GET_CALENDAR_DIAGNOSES_QUERY)
    },
    onError: (error: Error) => {
      toast.error(
        `Não foi possível salvar as informações, tente novamente mais tarde. [${error?.message}]`,
      )
    },
  })

  return mutation
}
